"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidHttpUrl = void 0;
const url_1 = require("url");
function isValidHttpUrl(input) {
    let url;
    try {
        url = new url_1.URL(input);
        return url.protocol === "http:" || url.protocol === "https:";
    }
    catch (e) {
        return false;
    }
}
exports.isValidHttpUrl = isValidHttpUrl;
//# sourceMappingURL=util.js.map